/**
 * @generated SignedSource<<ebc2a9831073cf23034c0ee149cc1cb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerNewsletterArticleArticle$data = {
  readonly headline: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"breadcrumbNewsletterArticleArticle" | "issuesNewsletterArticleArticle">;
  readonly " $fragmentType": "headerNewsletterArticleArticle";
};
export type headerNewsletterArticleArticle$key = {
  readonly " $data"?: headerNewsletterArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerNewsletterArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerNewsletterArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "issuesNewsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "breadcrumbNewsletterArticleArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "d5029c57f52160e640d2b8db87f91e07";

export default node;
